module.exports = __webpack_public_path__ + "static/media/warning.fe3545b2.svg";